import React from "react";
import { inject } from "mt-react-decorators";
import {
  Chart,
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Filler
} from "chart.js";

Chart.register(
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Filler
);

import { Radar } from "react-chartjs-2";

let colors = [
  {
    background: "rgba(54, 162, 235, 0.2)",
    border: "rgba(54, 162, 235, 1)"
  },
  {
    background: "rgba(255, 99, 132, 0.2)",
    border: "rgba(255, 99, 132, 1)"
  },

  {
    background: "rgba(153, 102, 255, 0.2)",
    border: "rgba(153, 102, 255, 1)"
  },
  {
    background: "rgba(255, 206, 86, 0.2)",
    border: "rgba(255, 206, 86, 1)"
  },

  {
    background: "rgba(75, 192, 192, 0.2)",
    border: "rgba(75, 192, 192, 1)"
  }
];
@inject(["manager"])
export default class TotalsGraph extends React.Component {
  get manager() {
    return this.props.manager;
  }

  get chartData() {
    let data = this.manager.graphData;

    data.forEach(data_val => {
      Object.keys(this.captions).forEach(key => {
        if (!data_val.data.hasOwnProperty(key)) {
          data_val.data[key] = 0;
        }
      });
    });

    return data;
  }

  get captions() {
    return {
      Organisational: "Organisational",
      Democratic: "Democratic",
      Political: "Political",
      Financial: "Financial"
    };
  }

  render() {
    return (
      <div
        className={
          "mtt-sustainability-tool__graph mtt-sustainability-tool__wrap"
        }
      >
        <div
          className={
            "mtt-sustainability-tool__graph-title mtt-sustainability-tool__wrap-title"
          }
        >
          Graph
        </div>
        <div style={{ width: 600, height: 600 }}>
          <Radar
            data={{
              labels: [
                "Organisational",
                "Democratic",
                "Political",
                "Financial"
              ],
              datasets: this.chartData.map((f, i) => ({
                label: "Average",
                data: Object.values(f.data),
                backgroundColor: colors[i].background,
                borderColor: colors[i].border,
                borderWidth: 1
              }))
            }}
            options={{
              plugins: {
                legend: {
                  display: false
                }
              },
              scales: {
                r: {
                  min: 1,
                  max: 5,
                  grid: { display: true },
                  angleLines: { display: true }
                }
              }
            }}
          />
        </div>
      </div>
    );
  }
}
